import React, { Suspense, lazy } from 'react';
import {
  Box, CircularProgress, Drawer, Popover,
} from '@mui/material';

// Loaded only when a picker is opened so the main bundle stays small.
const EmojiPicker = lazy(() => import('emoji-picker-react'));

const PickerPanel = ({ onSelect, autoFocusSearch }) => (
  <Suspense
    fallback={(
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress size={24} />
      </Box>
    )}
  >
    <EmojiPicker
      onEmojiClick={(data) => onSelect(data.emoji)}
      emojiStyle="native"
      lazyLoadEmojis
      autoFocusSearch={autoFocusSearch}
      previewConfig={{ showPreview: false }}
      searchPlaceholder="Search emoji"
      width="100%"
      height={380}
    />
  </Suspense>
);

/** Native-emoji picker: a bottom sheet on phones, a popover on larger screens. */
const EmojiPickerPopover = ({
  open, anchorEl, onClose, onSelect, isMobile,
}) => {
  if (isMobile) {
    return (
      <Drawer
        anchor="bottom"
        open={open}
        onClose={onClose}
        PaperProps={{ sx: { pb: 'env(safe-area-inset-bottom)', borderTopLeftRadius: 12, borderTopRightRadius: 12 } }}
      >
        {open && <PickerPanel onSelect={onSelect} autoFocusSearch={false} />}
      </Drawer>
    );
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Box sx={{ width: 350 }}>
        {open && <PickerPanel onSelect={onSelect} autoFocusSearch />}
      </Box>
    </Popover>
  );
};

export default EmojiPickerPopover;
